import _ from 'lodash'
import { GetterTree } from 'vuex'
import { State } from '../../../store'
import FormComponentState from './states'

const getters: GetterTree<FormComponentState, State> = {
  getByName: (state: any) => (formName: string): any => {
    return { ...(state.data[formName] || {}) }
  },
  getFormValue: (state: any) => (formName: string, attrName: string): any => {
    return _.get(state.data, `[${formName}][${attrName}]`, null)
  },
}

export default getters
